"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNameInitials = exports.humanFileSize = exports.capitalize = exports.rem = void 0;

var _numbers = require("./numbers");

// convert px to rem
var rem = function rem(pixel) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 13;
  var value = 0;

  if ((0, _numbers.isNumeric)(pixel) && (0, _numbers.isNumeric)(context)) {
    value = pixel / context;
    var decimal = String(value).split('.')[1];

    if (decimal && decimal.length > 8) {
      value = value.toFixed(8);
    }
  }

  return "".concat(value, "rem");
};

exports.rem = rem;

var overFirstLetter = function overFirstLetter(f) {
  return function (string) {
    if (!string || string.length === 0) return '';
    return f(string[0]) + string.slice(1);
  };
};

var capitalize = overFirstLetter(function (l) {
  return l.toUpperCase();
}); // Lifted from https://stackoverflow.com/a/20732091

exports.capitalize = capitalize;

var humanFileSize = function humanFileSize(bytes) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!(0, _numbers.isNumeric)(bytes)) return null;
  if (bytes === 0) return '0 B';
  var i = Math.floor(Math.log(bytes) / Math.log(1024));
  return "".concat((bytes / Math.pow(1024, i)).toFixed(precision) * 1, " ").concat(['B', 'KB', 'MB', 'GB', 'TB'][i]);
}; // Get the first letters of fullname


exports.humanFileSize = humanFileSize;

var getNameInitials = function getNameInitials(fullname) {
  if (!fullname || typeof fullname !== 'string') {
    return '';
  }

  var nameArr = fullname.split(/\s/);

  if (nameArr.length > 1) {
    return "".concat(nameArr[0][0]).concat(nameArr[1][0]);
  }

  return "".concat(nameArr[0][0]).concat(nameArr[0][1]);
};

exports.getNameInitials = getNameInitials;
//# sourceMappingURL=strings.js.map